import { styled } from "../../../stitches.config";
import { Box, FlexBox } from "../../primitives";

export const WrapperIcon = styled(FlexBox, {
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
});

export const IconNameText = styled(Box, {
  fontSize: 10,
  fontWeight: "bold",
});
